import { SidebarState } from "../../Models/RightSidebarState";
import { CLOSE_SIDEBAR, OPEN_SIDEBAR, TOGGLE_SIDEBAR } from "./SidebarTypes";

const initialState: SidebarState = {
  isOpen: false,
  loading: false,
  error: null,
};

const SidebarReducer = (state = initialState, action: any): SidebarState => {
  switch (action.type) {
    case OPEN_SIDEBAR:
      return { ...state, isOpen: true };
    case CLOSE_SIDEBAR:
      return { ...state, isOpen: false };
    case TOGGLE_SIDEBAR:
      return { ...state, isOpen: !state.isOpen };
    default:
      return state;
  }
};

export default SidebarReducer;